import { SectionsSubjects } from '../academic/learning-path/sections-subjects.interface';
export class GeneralUserData {
  // academicDetails
  classId?: number;
  sectionId?: number;
  rollNumber?: number;
  educationalProgramId?: number;
  schoolId: number;
  academicYearId: number;
  academicProgramId: number;
  // contact detail
  email: string;
  phoneNumber: string;
  address: string;
  city: string;
  zipCode: string;
  // personal info
  id?: string;
  profileImg: string;
  birthDate: Date;
  genderId: number;
  bloodGroupId: number;
  firstName: string;
  secondName: string;
  thirdName: string;
  lastName: string;
  firstNameEn: string;
  secondNameEn: string;
  thirdNameEn: string;
  lastNameEn: string;
  userName: string;
  nationalityId: number;
  specialNeeds: boolean;
  semester?: number;
  // skills and social
  skillsIds: number[];
  facebookUrl: string;
  linkedinUrl: string;
  twitterUrl: string;
  newSkills: string[];
  // parent info
  motherName: string;
  motherEmail: string;
  motherPhoneNumber: string;
  fatherName: string;
  fatherEmail: string;
  fatherPhoneNumber: string;
  sonWorkers?: boolean;
  guardianId?: string;
  // application user
  password: string = '123456';
  confirmPassword: string = '123456';
  userTypeId?: number;
  userNumber: string;
  statusId: number;
  isDeleted: boolean = false;
  idType: number;
  idNo: string;
  idIssueDate?: Date;
  idExpiryDate?: Date;
  languagesIds: number[];
  religionId: number;
  placeOfBirth: string;
  weight: number;
  height: number;
  userSchoolId: number;
  medicalNote: string;
  // subject
  subjects?: SectionsSubjects[];
}
